import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import getFinancialReportsService, {
  getEconomicInfoService,
  getFinancialRatiosService,
  getBusinessResultFundBankService,
  getBusinessResultFundInsuranceService,
  getBusinessResultFundSecuritiesService,
  getBusinessResultFundCompanyService,
} from 'services/analyticsCenter/economicInformation';
import {
  EconomicInfoTypes, FinancialRatiosDataTypes,
  FinancialRatiosParamsTypes, FinancialReportsItemTypes,
  FinancialReportsParamsTypes,
  FinancialReportsTypes, MetaTypes,
  BusinessResultParamsDataTypes,
  StoxTBFundDataTypes,
} from 'services/analyticsCenter/economicInformation/types';

interface EconomicInfoState {
  planStatistics: EconomicInfoTypes[];
  businessResultList?: StoxTBFundDataTypes;
  financialReports: FinancialReportsItemTypes[];
  metaFinancialReport?: MetaTypes,
  financialRatios: FinancialRatiosDataTypes[];
}

const initialState: EconomicInfoState = {
  planStatistics: [],
  businessResultList: undefined,
  financialReports: [],
  metaFinancialReport: undefined,
  financialRatios: [],
};

export const getEconomicInfoAction = createAsyncThunk<
  EconomicInfoTypes[],
  string | undefined,
  { rejectValue: ErrorResponse }
>('economicInformationReducer/getEconomicInfoAction', async (params: string | undefined, { rejectWithValue }) => {
  try {
    return await getEconomicInfoService(params);
  } catch (error) {
    return rejectWithValue(error as ErrorResponse);
  }
});

export const getFinancialRatiosAction = createAsyncThunk<
  FinancialRatiosDataTypes[],
  FinancialRatiosParamsTypes,
  { rejectValue: ErrorResponse }
>(
  'economicInformationReducer/getFinancialRatiosAction',
  async (params: FinancialRatiosParamsTypes, { rejectWithValue }) => {
    try {
      return await getFinancialRatiosService(params);
    } catch (error) {
      return rejectWithValue(error as ErrorResponse);
    }
  },
);

// data BussinessReult
export const getBusinessResultFundBankAction = createAsyncThunk<
  StoxTBFundDataTypes,
  BusinessResultParamsDataTypes,
  { rejectValue: ErrorResponse }
>('economicInformationReducer/getBusinessResultFundBankList',
  async (params: BusinessResultParamsDataTypes,
    { rejectWithValue }) => {
    try {
      return await getBusinessResultFundBankService(params);
    } catch (error) {
      return rejectWithValue(error as ErrorResponse);
    }
  });

export const getBusinessResultFundInsuranceAction = createAsyncThunk<
  StoxTBFundDataTypes,
  BusinessResultParamsDataTypes,
  { rejectValue: ErrorResponse }
>('economicInformationReducer/getBusinessResultFundInsuranceList',
  async (params: BusinessResultParamsDataTypes,
    { rejectWithValue }) => {
    try {
      return await getBusinessResultFundInsuranceService(params);
    } catch (error) {
      return rejectWithValue(error as ErrorResponse);
    }
  });

export const getBusinessResultFundSecuritiesAction = createAsyncThunk<
  StoxTBFundDataTypes,
  BusinessResultParamsDataTypes,
  { rejectValue: ErrorResponse }
>('economicInformationReducer/getBusinessResultFundSecuritiesList',
  async (params: BusinessResultParamsDataTypes,
    { rejectWithValue }) => {
    try {
      return await getBusinessResultFundSecuritiesService(params);
    } catch (error) {
      return rejectWithValue(error as ErrorResponse);
    }
  });

export const getBusinessResultFundCompanyAction = createAsyncThunk<
  StoxTBFundDataTypes,
  BusinessResultParamsDataTypes,
  { rejectValue: ErrorResponse }
>('economicInformationReducer/getBusinessResultFundCompanyList',
  async (params: BusinessResultParamsDataTypes,
    { rejectWithValue }) => {
    try {
      return await getBusinessResultFundCompanyService(params);
    } catch (error) {
      return rejectWithValue(error as ErrorResponse);
    }
  });
//

export const getEconomicInformationAction = createAsyncThunk<
  FinancialReportsTypes,
  FinancialReportsParamsTypes,
  { rejectValue: ErrorResponse }
>('economicInformationReducer/getFinancialReportsList',
  async (params: FinancialReportsParamsTypes,
    { rejectWithValue }) => {
    try {
      return await getFinancialReportsService(params);
    } catch (error) {
      return rejectWithValue(error as ErrorResponse);
    }
  });

const EconomicInfoSlice = createSlice({
  name: 'economicInformationReducer',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getEconomicInfoAction.fulfilled, ($state, action) => {
      $state.planStatistics = action.payload;
    });
    builder.addCase(getBusinessResultFundBankAction.fulfilled, ($state, action) => {
      $state.businessResultList = action.payload;
    });
    builder.addCase(getBusinessResultFundInsuranceAction.fulfilled, ($state, action) => {
      $state.businessResultList = action.payload;
    });
    builder.addCase(getBusinessResultFundSecuritiesAction.fulfilled, ($state, action) => {
      $state.businessResultList = action.payload;
    });
    builder.addCase(getBusinessResultFundCompanyAction.fulfilled, ($state, action) => {
      $state.businessResultList = action.payload;
    });
    builder.addCase(getEconomicInformationAction.fulfilled, ($state, action) => {
      $state.financialReports = action.payload.data;
      $state.metaFinancialReport = action.payload.meta;
    });
    builder.addCase(getFinancialRatiosAction.fulfilled, ($state, action) => {
      $state.financialRatios = action.payload;
    });
  },
});
export default EconomicInfoSlice.reducer;
